import * as React from "react"; //import ReactDOM from 'react-dom';
//import './App.css';

import IndexPolizaEndorsements from "../polizaEndorsements/IndexPolizaEndorsements";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'; //import { createBrowserHistory } from "history";
//import './index.css';

var ListPolizaEndorsementsApp = function ListPolizaEndorsementsApp(props) {
  var queryClient = new QueryClient();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(QueryClientProvider, {
    client: queryClient
  }, /*#__PURE__*/React.createElement(IndexPolizaEndorsements, props)));
}; //document.addEventListener("DOMContentLoaded", () => {
//  ReactDOM.render(
//    <React.StrictMode>
//      <App />
//    </React.StrictMode>,
//    document.getElementById('root')
//  );
//})


export default ListPolizaEndorsementsApp;